import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { axiosInt, type IScreen, API_INTERACT_URL } from '..';

export const FETCH_SCREEN_KEY = 'fetchScreen';
export const fetchScreenApi = async (
  id: string,
  params: Record<string, any> = {}
): Promise<IScreen> => {
  const response = await axiosInt.get(
    `${API_INTERACT_URL}/screens/read/${id}`,
    { params }
  );
  return response.data;
};

export const useFetchScreen = (
  id: string,
  params: Record<string, any> = {},
  options?: Partial<
    UseQueryOptions<IScreen, Error, IScreen, readonly unknown[]>
  >
) => {
  const {
    data: screen,
    isLoading: isLoadingScreen,
    error: errorFetchingScreen,
  } = useQuery<IScreen, Error, IScreen, readonly unknown[]>({
    queryKey: [FETCH_SCREEN_KEY, id],
    queryFn: () => fetchScreenApi(id, params),
    ...options,
  });

  return { screen, isLoadingScreen, errorFetchingScreen };
};
